import * as React from 'react';
import { Component } from 'react';
import { AppSchoolsUser2 } from '../AppSchools2';
import { saveAs } from 'file-saver';
import { getBucketConfigBP, sendUploadFileNotification } from '../../../services/schoolUser/schools';
import * as propz from 'propz';
import * as AWS from 'aws-sdk';
import { Loader } from '../../../components/Loader/Loader';
import { SimpleModal } from '../../../components/SimpleModal/SimpleModal';
import * as Moment from 'moment';
import { DATE_TIME_FORMAT } from '../../../consts/consts';
import * as JSZip from 'jszip';
import * as BPromise from 'bluebird';
import { SchoolAppUploadFilesViewForm2 } from '../SchoolAppUploadFilesViewForm2/SchoolAppUploadFilesViewForm2';
import { FolderDownloadButton } from '../FolderDownloadButton/FolderDownloadButton';

interface Props {
  user: AppSchoolsUser2;
  history: History;
}

interface State {
  bucketName: string;
  bucketRegion: string;
  identityPoolId: string;
  isLoading: boolean;
  albumsAndPhotos: any[];
  activeAlbum: any;
  activePrefix: string;
  isCreateDirFormModalOpen: boolean;
  inDropZone: boolean;
  uploading: boolean;
  isAdminToHaveSchool: boolean;
  isConfirmationModalOpen: boolean;
  isInfoModalOpen: boolean;
  infoMessage: string;
  activeItemIndex: number;
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken: string;
  initialPath: string;
  folderExists: boolean;
  isPreviewModalOpen: boolean;
  previewModalContent: React.ReactNode;
  downloadError: string | null;
}

interface FileWithRelativePath extends File {
  webkitRelativePath: string;
}

const BUCKET_DATA_TYPE = {
  ALBUM: 'album',
  FILE: 'file',
};

export class SchoolAppUploadFilesView2 extends Component<Props, State> {
  myRefUploadFile: any;
  myRefUploadFolder: any;
  activeSchoolReferenceCode: string = '';
  activeSchoolName: string = '';

  constructor(props: Props) {
    super(props);
    this.state = {
      bucketName: '',
      bucketRegion: '',
      identityPoolId: '',
      isLoading: true,
      albumsAndPhotos: [],
      activeAlbum: undefined,
      activePrefix: '',
      isCreateDirFormModalOpen: false,
      inDropZone: false,
      uploading: false,
      isAdminToHaveSchool: true,
      isConfirmationModalOpen: false,
      isInfoModalOpen: false,
      infoMessage: '',
      activeItemIndex: 0,
      accessKeyId: '',
      secretAccessKey: '',
      sessionToken: '',
      initialPath: '',
      folderExists: true,
      isPreviewModalOpen: false,
      previewModalContent: null,
      downloadError: null,
    };
    this.myRefUploadFile = React.createRef();
    this.myRefUploadFolder = React.createRef();
  }

  componentDidMount() {
    const { user } = this.props;

    this.setState({ isLoading: true });

    getBucketConfigBP(user).then(config => {
      const {
        bucketName,
        bucketRegion,
        AccessKeyId: accessKeyId,
        SecretKey: secretAccessKey,
        SessionToken: sessionToken,
      } = config;

      this.setState({
        accessKeyId,
        secretAccessKey,
        sessionToken,
        bucketName,
        bucketRegion,
      });

      this.activeSchoolReferenceCode = propz.get(user, ['activeSchool', 'code'], '');
      this.activeSchoolName = propz.get(this.props.user, ['activeSchool', 'name'], '');

      const currentPath = window.location.pathname;
      const basePath = `${this.activeSchoolReferenceCode}/`;
      const normalizedPath = this.normalizePath(currentPath.replace('/upload', ''));

      this.setState({ initialPath: basePath });

      this.getFullAlbums(basePath, normalizedPath);
    });
  }

  normalizePath(path: string): string {
    return path.replace(/\/+/g, '/').replace(/\/$/, '');
  }

  getBucketCredentials() {
    const { bucketName, bucketRegion, accessKeyId, secretAccessKey, sessionToken } = this.state;

    AWS.config.update({
      region: bucketRegion,
    });

    const credentials = new AWS.Credentials({
      accessKeyId,
      secretAccessKey,
      sessionToken,
    });

    AWS.config.credentials = credentials;

    const s3 = new AWS.S3({
      params: { Bucket: bucketName },
    });

    return s3;
  }

  getPresignedUrl(key: string, fileType: string) {
    const s3 = this.getBucketCredentials();
    const params = {
      Bucket: this.state.bucketName,
      Key: key,
      Expires: 3600,
    };

    if (fileType === 'pdf') {
      params['ResponseContentType'] = 'application/pdf';
    }

    return s3.getSignedUrl('getObject', params);
  }

  isAlbum = name => {
    return name[name.length - 1] === '/';
  };

  showSendingInfoModal = text => {
    this.setState({
      infoMessage: text,
      isInfoModalOpen: true,
    });
  };

  showPreviewModal = (fileKey: string, fileType: string) => {
    const url = this.getPresignedUrl(fileKey, fileType);

    let content;
    if (fileType === 'image') {
      content = <img src={url} alt="Preview" style={{ maxWidth: '100%', maxHeight: '100%' }} />;

      this.setState({
        previewModalContent: content,
        isPreviewModalOpen: true,
      });
    } else if (fileType === 'pdf') {
      const pdfWindow = window.open(url, '_blank');

      if (pdfWindow) {
        pdfWindow.focus();
      } else {
        alert('Please allow pop-ups for this website to view the PDF.');
      }

      this.setState({
        isPreviewModalOpen: false,
      });
    } else {
      content = <p>Cannot preview this file type</p>;

      this.setState({
        previewModalContent: content,
        isPreviewModalOpen: true,
      });
    }
  };

  getFullAlbums(basePath: string, targetFolder: string) {
    const { bucketName } = this.state;
    const s3 = this.getBucketCredentials();

    s3.listObjectsV2({ Delimiter: '/', Prefix: basePath, Bucket: bucketName }, (err, data) => {
      if (err) {
        this.setState({ isLoading: false });
        const infoMessage = 'There was an error viewing your album: ' + err.message;
        return this.showSendingInfoModal(infoMessage);
      }

      const folders = (data.CommonPrefixes || []).map(prefix => prefix.Prefix.trim());

      const normalizedTargetFolder = `${basePath}${targetFolder.replace(/^\//, '')}`.trim();
      const targetWithTrailingSlash = normalizedTargetFolder.endsWith('/')
        ? normalizedTargetFolder
        : normalizedTargetFolder + '/';

      const matchedFolder = folders.find(
        folder => folder.trim().toLowerCase() === targetWithTrailingSlash.toLowerCase()
      );

      if (!matchedFolder) {
        this.setState({
          albumsAndPhotos: [],
          activePrefix: basePath,
          activeAlbum: null,
          isLoading: false,
          isAdminToHaveSchool: false,
          folderExists: false,
        });
        return;
      }

      const normalizedPrefix = this.normalizePath(matchedFolder);
      this.fetchFolderContents(normalizedPrefix);
    });
  }

  onSchoolAlbumClick(event, album, activeAlbumKey) {
    if (event) {
      event.preventDefault();
    }

    this.setState({ isLoading: true });

    const s3 = this.getBucketCredentials();
    const prefix = album.Key.endsWith('/') ? album.Key : album.Key + '/';

    s3.listObjectsV2({ Delimiter: '/', Prefix: prefix, Bucket: this.state.bucketName }, (err, data) => {
      if (err) {
        this.setState({ isLoading: false });
        const infoMessage = 'There was an error viewing your album: ' + err.message;
        return this.showSendingInfoModal(infoMessage);
      }

      let items = [];

      if (data.CommonPrefixes) {
        const folders = data.CommonPrefixes.map(prefixObj => {
          const key = prefixObj.Prefix;
          const name = decodeURIComponent(key.replace(prefix, '').replace(/\/$/, ''));
          return {
            name: name || '-',
            Key: key,
            type: BUCKET_DATA_TYPE.ALBUM,
            size: 0,
            lastModified: null,
            allKeys: (data.Contents || []).filter(c => !c.Key!.endsWith('/')).map(c => c.Key!),
          };
        });
        items = [...items, ...folders];
      }

      if (data.Contents) {
        const files = data.Contents.map(content => {
          const key = content.Key;
          const name = decodeURIComponent(key.replace(prefix, ''));
          const type = this.isAlbum(key) ? BUCKET_DATA_TYPE.ALBUM : BUCKET_DATA_TYPE.FILE;
          return {
            name: name || '-',
            Key: key,
            type,
            size: content.Size,
            lastModified: content.LastModified,
          };
        });
        items = [...items, ...files];
      }

      items = items.filter(item => item.Key !== prefix);

      items.sort((a, b) => {
        if (a.type === b.type) {
          return a.name.localeCompare(b.name);
        }
        return a.type === BUCKET_DATA_TYPE.ALBUM ? -1 : 1;
      });

      this.setState({
        albumsAndPhotos: items,
        activePrefix: data.Prefix,
        activeAlbum: album,
        isLoading: false,
      });
    });
  }

  async fetchFolderContents(prefix: string) {
    const { bucketName, activePrefix } = this.state;

    if (prefix === activePrefix) {
      this.setState({ isLoading: false });
      return;
    }

    this.setState({ isLoading: true, activePrefix: prefix });
    const s3 = this.getBucketCredentials();

    try {
      const data = await s3.listObjectsV2({ Delimiter: '/', Prefix: prefix, Bucket: bucketName }).promise();

      const folders = await Promise.all(
        (data.CommonPrefixes || []).map(async prefixObj => {
          const key = prefixObj.Prefix;
          const allKeys: string[] = [];
          let ContinuationToken: string | undefined = undefined;

          do {
            const resp = await s3.listObjectsV2({ Bucket: bucketName, Prefix: key, ContinuationToken }).promise();
            allKeys.push(...(resp.Contents || []).filter(o => !o.Key!.endsWith('/')).map(o => o.Key!));
            ContinuationToken = resp.IsTruncated ? resp.NextContinuationToken! : undefined;
          } while (ContinuationToken);

          return {
            name: decodeURIComponent(key.replace(prefix, '').replace(/\/$/, '')) || '-',
            Key: key,
            type: BUCKET_DATA_TYPE.ALBUM,
            size: 0,
            lastModified: null,
            allKeys,
          };
        })
      );

      const files = (data.Contents || []).map(content => {
        const key = content.Key!;
        return {
          name: decodeURIComponent(key.replace(prefix, '').replace('/', '')) || '-',
          Key: key,
          type: this.isAlbum(key) ? BUCKET_DATA_TYPE.ALBUM : BUCKET_DATA_TYPE.FILE,
          size: content.Size,
          lastModified: content.LastModified,
        };
      });

      const items = [...folders, ...files].filter(i => i.Key !== prefix);
      items.sort((a, b) => {
        if (a.type === b.type) return a.name.localeCompare(b.name);
        return a.type === BUCKET_DATA_TYPE.ALBUM ? -1 : 1;
      });

      this.setState({
        albumsAndPhotos: items,
        activeAlbum: items[0] || null,
        isLoading: false,
        isAdminToHaveSchool: true,
      });

      if (items.length > 0 && prefix !== `${this.activeSchoolReferenceCode}/`) {
        this.onSchoolAlbumClick(undefined, items[0], items[0].Key);
      }
    } catch (err) {
      this.setState({ isLoading: false });
      this.showSendingInfoModal('There was an error viewing your album: ' + err.message);
    }
  }

  hideSendingInfoClick = () => {
    this.setState({
      isInfoModalOpen: false,
    });
  };

  renderSendingInfo(): React.ReactNode {
    const { infoMessage, isInfoModalOpen } = this.state;
    const modalTitle = infoMessage.includes('Error') ? 'Error' : 'Confirmation';

    return (
      <SimpleModal isOpen={isInfoModalOpen} customClass="custom-user-modal">
        <div className="custom-modal-header">
          <h5>{modalTitle}</h5>
          <button className="close" onClick={this.hideSendingInfoClick}>
            &times;
          </button>
        </div>

        <div className="custom-modal-body">{infoMessage}</div>
        <div className="custom-button-container" style={{ marginTop: '20px' }}>
          <button onClick={this.hideSendingInfoClick} className="custom-button">
            <img src="/dist/images/icon/cancel.png" alt="Close" className="custom-edit-icon" />
            Close
          </button>
        </div>
      </SimpleModal>
    );
  }

  renderPreviewModal() {
    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      if (e.target === e.currentTarget) {
        this.setState({ isPreviewModalOpen: false });
      }
    };

    return (
      this.state.isPreviewModalOpen && (
        <div
          className="custom-modal-backdrop"
          onClick={handleBackdropClick}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            className="custom-modal-container"
            onClick={e => e.stopPropagation()}
            style={{
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '8px',
              width: '80%',
              maxWidth: '600px',
              maxHeight: '90vh',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <button onClick={() => this.setState({ isPreviewModalOpen: false })} style={{ marginBottom: '10px' }}>
              Close
            </button>
            <div style={{ maxHeight: '85vh', overflowY: 'auto' }}>{this.state.previewModalContent}</div>
          </div>
        </div>
      )
    );
  }

  onDeleteAlbumClick(album) {
    const albumName = propz.get(album, ['Key'], '');
    const s3 = this.getBucketCredentials();
    let albumKey = encodeURIComponent(albumName) + '/';
    const { activeAlbum, bucketName } = this.state;
    this.setState({
      isLoading: true,
    });
    s3.listObjects({ Prefix: albumName, Bucket: bucketName }, (err, data) => {
      if (err) {
        console.log(err.message);
        this.setState({
          isLoading: false,
        });
        const infoMessage = `There was an error deleting your album: ${err.message}`;
        return this.showSendingInfoModal(infoMessage);
      }
      let objects = data.Contents.map(function(object) {
        return { Key: object.Key };
      });
      s3.deleteObjects(
        {
          Delete: { Objects: objects, Quiet: true },
          Bucket: bucketName,
        },
        (err, data) => {
          if (err) {
            this.setState({
              isLoading: false,
            });
            const infoMessage = `There was an error deleting your album: ${err.message}`;
            return this.showSendingInfoModal(infoMessage);
          }
          this.setState({
            isLoading: false,
          });
          this.setState({
            isLoading: false,
          });
          const infoMessage = 'Folder has been deleted.';
          this.showSendingInfoModal(infoMessage);
          this.onSchoolAlbumClick(undefined, activeAlbum, activeAlbum.Key);
        }
      );
    });
  }

  onDeleteClick = (item, isAlbum) => {
    this.setState({
      isConfirmationModalOpen: false,
    });
    if (isAlbum) {
      this.onDeleteAlbumClick(item);
    } else {
      this.onDeleteFileClick(item);
    }
  };

  onDeleteFileClick(album) {
    const { activeAlbum, bucketName } = this.state;
    const s3 = this.getBucketCredentials();

    s3.deleteObject({ Key: album.Key, Bucket: bucketName }, (err, data) => {
      if (err) {
        const infoMessage = `There was an error deleting your file: ${err.message}`;
        return this.showSendingInfoModal(infoMessage);
      }
      const infoMessage = 'File has been deleted.';
      this.showSendingInfoModal(infoMessage);
      this.onSchoolAlbumClick(undefined, activeAlbum, activeAlbum.Key);
    });
  }

  renderConfirmationModal(): React.ReactNode {
    const { isConfirmationModalOpen, activeItemIndex, albumsAndPhotos } = this.state;
    const item = albumsAndPhotos[activeItemIndex];
    const albumType = albumsAndPhotos.length > 0 ? propz.get(item, ['type'], 'album') : 'album';
    const isAlbum = albumType === BUCKET_DATA_TYPE.ALBUM;
    const infoMessage = isAlbum
      ? 'Folder and its content will be deleted. Are you sure?'
      : 'File will be deleted. Are you sure?';
    return (
      <SimpleModal
        isOpen={isConfirmationModalOpen}
        title={'Confirmation'}
        body={infoMessage}
        buttonText={'Ok'}
        buttonCancelText={'Cancel'}
        onButtonClick={() => this.onDeleteClick(item, isAlbum)}
        onCloseClick={this.hideConfirmationModal}
      />
    );
  }

  hideConfirmationModal = () => {
    this.setState({
      isConfirmationModalOpen: false,
    });
  };

  onCancelButtonClick = () => {
    this.setState({
      isCreateDirFormModalOpen: false,
    });
  };

  showCreateDirFormModal = () => {
    this.setState({
      isCreateDirFormModalOpen: true,
    });
  };

  createAlbum(albumBucketName) {
    const { bucketName } = this.state;
    const s3 = this.getBucketCredentials();
    const albumName = albumBucketName.split(' ').join(' ');

    if (!albumName) {
      const infoMessage = 'Album names must contain at least one non-space character.';
      return this.showSendingInfoModal(infoMessage);
    }

    if (albumName.indexOf('/') !== -1) {
      const infoMessage = 'Album names cannot contain slashes.';
      return this.showSendingInfoModal(infoMessage);
    }

    this.setState({
      isLoading: true,
    });

    const key = propz.get(this.state, ['activeAlbum', 'Key'], '');
    const albumKeyWithSlash = key[key.length - 1] !== '/' ? key + '/' : key;
    const albumKeyWithFirstSlash = albumKeyWithSlash[0] === '/' ? albumKeyWithSlash.slice(1) : albumKeyWithSlash;
    const pathAlbum = albumKeyWithFirstSlash + albumBucketName;

    s3.headObject({ Key: pathAlbum + '/', Bucket: bucketName }, (err, data) => {
      if (!err) {
        const infoMessage = 'Album already exists.';
        return this.showSendingInfoModal(infoMessage);
      }

      if (err.code !== 'NotFound') {
        const infoMessage = 'There was an error creating your album: ' + err.message;
        return this.showSendingInfoModal(infoMessage);
      }

      s3.putObject({ Key: pathAlbum + '/', Bucket: bucketName }, (err, data) => {
        if (err) {
          const infoMessage = 'There was an error creating your album: ' + err.message;
          return this.showSendingInfoModal(infoMessage);
        }

        if (key === '') {
          this.getFullAlbums('/', pathAlbum);
        } else {
          this.onSchoolAlbumClick(undefined, this.state.activeAlbum, albumKeyWithSlash);
        }

        this.setState({
          isLoading: false,
        });
      });
    });

    return true;
  }

  onSubmitCreateDirForm = value => {
    const albumBucketName = value.dirName;

    this.setState({
      isCreateDirFormModalOpen: false,
    });
    this.createAlbum(albumBucketName);
  };

  renderCreateDirFormModal(): React.ReactNode {
    const { isCreateDirFormModalOpen } = this.state;

    return (
      <SimpleModal isOpen={isCreateDirFormModalOpen}>
        <SchoolAppUploadFilesViewForm2 onCancel={this.onCancelButtonClick} onSubmit={this.onSubmitCreateDirForm} />
      </SimpleModal>
    );
  }

  addPhoto(acceptedFile) {
    const file = acceptedFile;
    const fileName = acceptedFile.name;

    const { activeAlbum, bucketName } = this.state;
    const key = propz.get(activeAlbum, ['Key'], '');
    const albumPhotosKey =
      typeof activeAlbum !== 'undefined' && activeAlbum.type === BUCKET_DATA_TYPE.FILE ? key + '/' : key;
    const photoKey =
      albumPhotosKey[albumPhotosKey.length - 1] !== '/' ? albumPhotosKey + '/' + fileName : albumPhotosKey + fileName;

    const upload = new AWS.S3.ManagedUpload({
      params: {
        Bucket: bucketName,
        Key: photoKey,
        Body: file,
      },
    });

    const promise = upload.promise();

    promise.then(
      data => {
        this.onSchoolAlbumClick(undefined, activeAlbum, activeAlbum.Key);
        this.showSendingInfoModal('File has been uploaded successfully.');
      },
      err => {
        const infoMessage = `There was an error uploading your file: ${err.message}`;
        return this.showSendingInfoModal(infoMessage);
      }
    );
  }

  onFolderDownloadClick(event, album) {
    event.preventDefault();
    const { bucketName } = this.state;
    const s3 = this.getBucketCredentials();
    this.setState({ isLoading: true });

    const folderKey = album.Key.endsWith('/') ? album.Key : album.Key + '/';
    const folderName = propz.get(album, ['name'], 'download');
    const zip = new JSZip();

    s3.listObjectsV2({ Prefix: folderKey, Bucket: bucketName }, (err, data) => {
      if (err) {
        this.setState({ isLoading: false });
        return this.showSendingInfoModal('There was an error downloading your folder: ' + err.message);
      }

      const fileKeys = (data.Contents || [])
        .map(obj => obj.Key!)
        .filter(key => key !== folderKey && !key.endsWith('/'));

      BPromise.all(
        fileKeys.map(
          key =>
            new BPromise((resolve, reject) => {
              s3.getObject({ Key: key, Bucket: bucketName }, (err, fileData) =>
                err ? reject(err) : resolve({ key, body: fileData.Body, contentType: fileData.ContentType })
              );
            })
        )
      )
        .then(results => {
          results.forEach(({ key, body, contentType }: any) => {
            const relativeName = key.replace(folderKey, '');
            zip.file(relativeName, new Blob([body], { type: contentType }));
          });
          return zip.generateAsync({ type: 'blob' });
        })
        .then(blob => {
          saveAs(blob, `${folderName}.zip`);
          this.setState({ isLoading: false });
        })
        .catch(err => {
          this.setState({ isLoading: false });
          this.showSendingInfoModal('There was an error downloading your folder: ' + err.message);
        });
    });
  }

  onFileDownloadClick(event, album) {
    if (typeof event !== 'undefined') {
      event.preventDefault();
    }
    const { bucketName } = this.state;
    const s3 = this.getBucketCredentials();
    this.setState({
      isLoading: true,
    });
    const key = propz.get(album, ['Key'], '-');
    const keyArray = key.split('/');
    const fileName = keyArray[keyArray.length - 1];

    s3.getObject({ Key: key, Bucket: bucketName }, (err, data: any) => {
      if (err) {
        this.setState({
          isLoading: false,
        });
        const infoMessage = 'Failed to retrieve an object ' + err.message;
        return this.showSendingInfoModal(infoMessage);
      }
      this.setState({
        isLoading: false,
      });

      const xml = new Blob([data.Body], { type: data.ContentType });
      if (window.navigator.msSaveBlob) {
        // IE 10+
        window.navigator.msSaveBlob(xml, fileName);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          /*global URL:true*/
          const url = URL.createObjectURL(xml);
          link.setAttribute('href', url);
          link.setAttribute('download', fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
  }

  showConfirmationModal = (event, index) => {
    event.preventDefault();

    this.setState({
      activeItemIndex: index,
      isConfirmationModalOpen: true,
    });
  };

  addPhotos(event) {
    const fileList = event.target.files;
    const files: any[] = Array.from(fileList);
    const { user } = this.props;
    BPromise.all(
      files.map(file => {
        this.setState({
          isLoading: true,
        });
        const fileName = file.name;

        const { activeAlbum, bucketName } = this.state;
        const key = propz.get(activeAlbum, ['Key'], '');
        const albumPhotosKey =
          typeof activeAlbum !== 'undefined' && activeAlbum.type === BUCKET_DATA_TYPE.FILE ? key + '/' : key;
        const photoKey =
          albumPhotosKey[albumPhotosKey.length - 1] !== '/'
            ? albumPhotosKey + '/' + fileName
            : albumPhotosKey + fileName;

        const result = new AWS.S3.ManagedUpload({
          params: {
            Bucket: bucketName,
            Key: photoKey,
            Body: file,
          },
        }).promise();

        return result;
      })
    )
      .then(() => {
        return sendUploadFileNotification(
          user,
          files.map(file => file.name)
        );
      })
      .then(res => {
        const { activeAlbum } = this.state;
        this.onSchoolAlbumClick(undefined, activeAlbum, activeAlbum.Key);
        const infoMessage = 'File has been uploaded';
        this.showSendingInfoModal(infoMessage);
      });
  }

  addFolder(event) {
    const fileList = event.target.files;
    const files: FileWithRelativePath[] = Array.from(fileList) as FileWithRelativePath[];

    const s3 = this.getBucketCredentials();
    const { bucketName, activePrefix } = this.state;

    if (files.length === 0) {
      this.setState({ isLoading: false });
      this.showSendingInfoModal('The folder is empty');
      return;
    }

    this.setState({ isLoading: true });

    const createFolderInS3 = (folderKey: string): Promise<void> => {
      return s3
        .putObject({
          Bucket: bucketName,
          Key: `${folderKey}/`,
          Body: '',
        })
        .promise()
        .then(() => undefined);
    };

    BPromise.all(
      files.map(file => {
        const relativePath = file.webkitRelativePath;
        const folderPath = relativePath
          .split('/')
          .slice(0, -1)
          .join('/');

        const completeFolderPath = `${activePrefix}${folderPath}`;

        return createFolderInS3(completeFolderPath).then(() => {
          const upload = new AWS.S3.ManagedUpload({
            params: {
              Bucket: bucketName,
              Key: `${completeFolderPath}/${file.name}`,
              Body: file,
            },
          });

          return upload.promise();
        });
      })
    )
      .then(() => {
        this.setState({ isLoading: false });
        this.showSendingInfoModal('Folder has been uploaded successfully.');

        this.onSchoolAlbumClick(undefined, { Key: activePrefix }, activePrefix);
      })
      .catch(err => {
        this.setState({ isLoading: false });
        this.showSendingInfoModal(`There was an error uploading the folder: ${err.message}`);
      });
  }

  setAcceptedFiles = acceptedFiles => {
    const s3 = this.getBucketCredentials();
    const { activeAlbum, bucketName } = this.state;
    const key = propz.get(activeAlbum, ['Key'], '');
    this.setState({
      isLoading: true,
    });
    BPromise.all(
      acceptedFiles.map(file => {
        const isFileInFolder = file.path[0] === '/';
        if (isFileInFolder) {
          const filePath = file.path.split('/');

          const albumNames = [...filePath];
          albumNames.splice(filePath.length - 1, 1);
          albumNames.splice(0, 1);

          let fullPath = albumNames[0];
          BPromise.all(
            albumNames.map((name, index) => {
              if (index > 0) {
                fullPath = fullPath + '/' + name;
              }
              const key = propz.get(this.state, ['activeAlbum', 'Key'], '');
              const albumKeyWithSlash = key[key.length - 1] !== '/' ? key + '/' : key;
              const pathAlbum = albumKeyWithSlash + fullPath;

              s3.putObject({ Key: pathAlbum + '/', Bucket: bucketName }, (err, data) => {
                if (err) {
                  const infoMessage = 'There was an error creating your album: ' + err.message;
                  return this.showSendingInfoModal(infoMessage);
                }
              });
            })
          ).then(res => {
            const fileName = file.path[0] === '/' ? file.path.slice(1) : file.path;
            const albumPhotosKey =
              typeof activeAlbum !== 'undefined' && activeAlbum.type === BUCKET_DATA_TYPE.FILE ? key + '/' : key;
            const photoKey =
              albumPhotosKey[albumPhotosKey.length - 1] !== '/'
                ? albumPhotosKey + '/' + fileName
                : albumPhotosKey + fileName;
            const upload = new AWS.S3.ManagedUpload({
              params: {
                Bucket: bucketName,
                Key: photoKey,
                Body: file,
              },
            });
            const promise = upload.promise();
            promise.then(
              data => {},
              err => {
                const infoMessage = `There was an error uploading your file: ${err.message}`;
                return this.showSendingInfoModal(infoMessage);
              }
            );
          });
        } else {
          this.addPhoto(file);
        }
      })
    ).then(res => {
      this.onSchoolAlbumClick(undefined, activeAlbum, activeAlbum.Key);
      const infoMessage = 'File has been uploaded';
      this.showSendingInfoModal(infoMessage);
    });
  };

  onBackClick = (event, newKey) => {
    event.preventDefault();

    this.setState({
      isLoading: true,
    });

    const activeAlbum = { ...this.state.activeAlbum };

    if (newKey !== '') {
      activeAlbum.Key = newKey;
      this.onSchoolAlbumClick(undefined, activeAlbum, activeAlbum.Key);
    } else {
      const activeSchoolReferenceCode = propz.get(this.props.user, ['activeSchool', 'name'], '');
      this.getFullAlbums(`${activeSchoolReferenceCode}/`, '/');
    }
  };

  renderTable = () => {
    const { albumsAndPhotos, activeAlbum, activePrefix, initialPath, folderExists } = this.state;
    const currentPath = window.location.pathname;

    if (!folderExists) {
      return <h5 className="mt-5">No files have been added yet.</h5>;
    }

    const bookingsFolderPath = `${this.activeSchoolReferenceCode}/bookings/`;
    const linksFolderPath = `${this.activeSchoolReferenceCode}/links/`;
    const imageDownloadsFolderPath = `${this.activeSchoolReferenceCode}/downloads/`;
    const pdfFolderPath = `${this.activeSchoolReferenceCode}/pdf/`;

    const pageDetails = {
      [`${this.activeSchoolReferenceCode}/bookings/`]: { icon: 'bookings.png', title: 'Bookings' },
      [`${this.activeSchoolReferenceCode}/links/`]: { icon: 'links.png', title: 'Links & Logins for Parents' },
      [`${this.activeSchoolReferenceCode}/downloads/`]: {
        icon: 'image-downloads.png',
        title: 'Images Available for Downloads',
      },
      [`${this.activeSchoolReferenceCode}/pdf/`]: { icon: 'pdf.png', title: 'PDF Documents' },
    };

    const showBackButton =
      activePrefix &&
      activePrefix !== initialPath &&
      ((activePrefix.startsWith(bookingsFolderPath) && activePrefix !== bookingsFolderPath) ||
        (activePrefix.startsWith(linksFolderPath) && activePrefix !== linksFolderPath) ||
        (activePrefix.startsWith(imageDownloadsFolderPath) && activePrefix !== imageDownloadsFolderPath) ||
        (activePrefix.startsWith(pdfFolderPath) && activePrefix !== pdfFolderPath));

    const activeAlbumKey = propz.get(activeAlbum, ['Key'], '');
    const keyArray = activeAlbumKey.split('/');
    keyArray.splice(keyArray.length - 2, 1);

    const rows = albumsAndPhotos.map((album, index) => {
      const name = propz.get(album, ['name'], '-');
      const lastModified = propz.get(album, ['lastModified']);
      const lastModifiedDate = lastModified ? Moment(new Date(lastModified)).format(DATE_TIME_FORMAT) : '-';
      const fileSize = propz.get(album, ['size'], 0);
      const fileGivenSize = fileSize > 0 ? `${(fileSize / 1024).toFixed(2)} KB` : '-';
      const isAlbum = album.type === BUCKET_DATA_TYPE.ALBUM;
      const key = propz.get(album, ['Key'], '');
      const albumPhotosKey = activeAlbum && activeAlbum.type === BUCKET_DATA_TYPE.FILE ? key + '/' : key;

      const isImage = /\.(jpg|jpeg|png|gif|bmp|tiff)$/i.test(name);
      const isPdf = /\.pdf$/i.test(name);

      return (
        <tr key={`album_${index}`}>
          <td className="first-column">
            {isAlbum ? (
              <div className="eUploadedFiles">
                <a href="" onClick={e => this.onSchoolAlbumClick(e, album, albumPhotosKey)} className="custom-link">
                  <svg
                    width="2em"
                    height="2em"
                    viewBox="0 0 16 16"
                    className="bi bi-folder2-open eUploadedFilesField"
                    fill="#34495e"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v.64c.57.265.94.876.856 1.546l-.64 5.124A2.5 2.5 0 0 1 12.733 15H3.266a2.5 2.5 0 0 1-2.481-2.19l-.64-5.124A1.5 1.5 0 0 1 1 6.14V3.5zM2 6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5a.5.5 0 0 0-.5.5V6zm-.367 1a.5.5 0 0 0-.496.562l.64 5.124A1.5 1.5 0 0 0 3.266 14h9.468a1.5 1.5 0 0 0 1.489-1.314l.64-5.124A.5.5 0 0 0 14.367 7H1.633z"
                    />
                  </svg>
                  <div className="ml-3 eUploadedFilesName">{name}</div>
                </a>
              </div>
            ) : (
              <div className="eUploadedFiles">
                <svg
                  width="2em"
                  height="2em"
                  viewBox="0 0 16 16"
                  className="bi bi-file-earmark eUploadedFilesField"
                  fill="#34495e"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M4 1h5v1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6h1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z" />
                  <path d="M9 4.5V1l5 5h-3.5A1.5 1.5 0 0 1 9 4.5z" />
                </svg>
                <div className="ml-3 eUploadedFilesName">{name}</div>
              </div>
            )}
          </td>
          <td>{lastModifiedDate}</td>
          <td>{fileGivenSize}</td>
          <td>
            {isImage && (
              <div className="custom-tooltip">
                <img
                  src="/dist/images/icon/preview.png"
                  alt="Preview"
                  onClick={() => this.showPreviewModal(album.Key, 'image')}
                  style={{ width: '2em', height: '2em' }}
                />
                <span className="tooltip-text">Image Preview</span>
              </div>
            )}
            {isPdf && (
              <div className="custom-tooltip">
                <img
                  src="/dist/images/icon/preview.png"
                  alt="Preview"
                  onClick={() => this.showPreviewModal(album.Key, 'pdf')}
                  style={{ width: '2em', height: '2em' }}
                />
                <span className="tooltip-text">PDF Preview</span>
              </div>
            )}
          </td>
          <td>
            {isAlbum ? (
              <FolderDownloadButton
                folderKey={album.Key}
                zipName={`${album.name}.zip`}
                presignUrl={key => this.getPresignedUrl(key, '')}
                bucketName={this.state.bucketName}
                region={this.state.bucketRegion}
                onError={msg => this.setState({ downloadError: msg })}
              />
            ) : (
              <div className="eUploadedFiles">
                <a
                  href=""
                  onClick={e => {
                    e.preventDefault();
                    this.onFileDownloadClick(e, album);
                  }}
                  className="custom-link"
                >
                  <svg
                    width="2em"
                    height="2em"
                    viewBox="0 0 16 16"
                    className="bi bi-download"
                    fill="#34495e"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"
                    />
                    <path
                      fillRule="evenodd"
                      d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"
                    />
                  </svg>
                </a>
              </div>
            )}
          </td>
        </tr>
      );
    });

    return (
      <div>
        <div className="buttons-container" style={{ marginBottom: '1rem' }}>
          {showBackButton && (
            <button type="button" onClick={e => this.onBackClick(e, keyArray.join('/'))} className="custom-button">
              <img src="/dist/images/icon/arrow-left.png" alt="Back" className="custom-edit-icon" />
              Back
            </button>
          )}
          {currentPath.startsWith('/upload/pdf') && (
            <div className="upload-buttons-container">
              <button type="button" onClick={e => this.myRefUploadFile.current.click()} className="custom-button">
                Upload File
              </button>
              <input
                type="file"
                ref={this.myRefUploadFile}
                onChange={e => this.addPhotos(e)}
                style={{ display: 'none' }}
                multiple
              />
              <button type="button" onClick={e => this.myRefUploadFolder.current.click()} className="custom-button">
                Upload Folder
              </button>
              <input
                type="file"
                ref={this.myRefUploadFolder}
                onChange={e => this.addFolder(e)}
                style={{ display: 'none' }}
                multiple
                {...({ directory: '', webkitdirectory: '', mozdirectory: '' } as any)}
              />
            </div>
          )}
        </div>
        <table className="table">
          <thead>
            <tr>
              <th style={{ width: '50%' }}>Name</th>
              <th>Last Modified</th>
              <th>Size</th>
              <th>Preview</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows
            ) : (
              <tr>
                <td colSpan={4}>No files have been added yet</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    const {
      isLoading,
      isCreateDirFormModalOpen,
      isConfirmationModalOpen,
      isInfoModalOpen,
      activePrefix,
      folderExists,
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const pageDetails = {
      [`${this.activeSchoolReferenceCode}/bookings/`]: { icon: 'bookings.png', title: 'Bookings' },
      [`${this.activeSchoolReferenceCode}/links/`]: { icon: 'links.png', title: 'Links & Logins for Parents' },
      [`${this.activeSchoolReferenceCode}/downloads/`]: {
        icon: 'image-downloads.png',
        title: 'Images Available for Download',
      },
      [`${this.activeSchoolReferenceCode}/pdf/`]: { icon: 'pdf.png', title: 'PDF Documents' },
    };

    const pathDisplayNames = {
      bookings: 'Bookings',
      links: 'Links & Logins for Parents',
      downloads: 'Images Available for Download',
      pdf: 'PDF Documents',
    };

    const currentPath = window.location.pathname;
    const pageType = Object.keys(pageDetails).find(key => currentPath.startsWith(`/upload/${key.split('/')[1]}`));
    const pageTitle = pageType ? pageDetails[pageType].title : '';
    const pageIcon = pageType ? `/dist/images/icon/${pageDetails[pageType].icon}` : '/dist/images/icon/default.png';

    const activePrefixParts = activePrefix.split('/').filter(part => part);
    const pointerText = activePrefixParts
      .map((part, index) => {
        if (index === 0) {
          return this.activeSchoolName;
        }
        return pathDisplayNames[part.toLowerCase()] || part;
      })
      .join('  >  ');

    const classes = isCreateDirFormModalOpen || isConfirmationModalOpen || isInfoModalOpen ? 'mt-3 modal-open' : 'mt-3';

    return (
      <div className="schoolAppContentWrapper2">
        <div className="page-header">
          <img src={pageIcon} alt={pageTitle} className="header-icon" />
          <h1>{pageTitle}</h1>
        </div>

        <div className="path-display" style={{ marginBottom: '1rem' }}>
          {pointerText}
        </div>
        {this.renderSendingInfo()}
        {this.renderConfirmationModal()}
        {this.renderPreviewModal()}
        {this.renderCreateDirFormModal()}
        {this.state.downloadError && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 2000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => this.setState({ downloadError: null })}
          >
            <div
              style={{
                background: '#fff',
                padding: '1.5rem',
                borderRadius: '8px',
                maxWidth: '90%',
                boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                position: 'relative',
              }}
              onClick={e => e.stopPropagation()}
            >
              <h5 style={{ marginTop: 0 }}>Download Error</h5>
              <div style={{ whiteSpace: 'pre-wrap', margin: '1rem 0' }}>{this.state.downloadError}</div>
              <button
                onClick={() => this.setState({ downloadError: null })}
                style={{
                  padding: '0.5rem 1rem',
                  border: 'none',
                  background: '#007bff',
                  color: '#fff',
                  borderRadius: '4px',
                  cursor: 'pointer',
                }}
              >
                Close
              </button>
            </div>
          </div>
        )}
        {folderExists ? this.renderTable() : <h5 className="mt-5">No files have been added yet.</h5>}
      </div>
    );
  }
}
